import { SearchQueryOrderDirection } from "types/generated";
import { GET_TEMPLATE_VERSION } from "views/Account/TemplateVersion/gql";

import { SEARCH_TEMPLATE_VERSIONS, SEARCH_TEMPLATE_VERSIONS_SUGGESTIONS } from "./gql";
import { GET_TEMPLATE } from "../gql";

export const initialSortOption = "state";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export const TEMPLATES_LIMIT = 50;

export const FILTERS_ORDER_SETTINGS_KEY = "templateVersionsFiltersOrder";

export const REFETCH_QUERIES_LIST = [
  SEARCH_TEMPLATE_VERSIONS,
  SEARCH_TEMPLATE_VERSIONS_SUGGESTIONS,
  GET_TEMPLATE_VERSION,
  GET_TEMPLATE,
];

export const FILTER_TYPE = "templateVersions";
export const TEMPLATES_LIMIT_STORAGE_KEY = "templateVersionsLimit";
